import { render, staticRenderFns } from "./ProjectAdmin.vue?vue&type=template&id=fc6f57f2&scoped=true"
import script from "./ProjectAdmin.vue?vue&type=script&lang=ts"
export * from "./ProjectAdmin.vue?vue&type=script&lang=ts"
import style0 from "./ProjectAdmin.vue?vue&type=style&index=0&id=fc6f57f2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc6f57f2",
  null
  
)

export default component.exports